module.exports = __webpack_public_path__ + "static/img/CaliforniaFoodHandler.f69cacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CaliforniaFoodHandler.png
// module id = 422
// module chunks = 4